export const DisclosureCategory = {
  CorssSell: 'Cross-Sell',
  Disclosure: 'Disclosure',
  SmartSign: 'Smart-Sign'
};
